'use client'

import { ButtonVariants } from '..'
import { ArrowLeftIcon } from '../../icons'
import {
    ICON_BUTTON_ARIA_LABEL_MESSAGE_KEYS,
    resolveIconButtonAriaLabel,
} from '../../../constants/iconButtonAriaLabelMessageKeys'
import { DictionaryContext } from '../../../providers'
import React, { ReactElement, useContext } from 'react'
import { LinkAsButton, LinkAsButtonProps } from './LinkAsButton'

interface Props extends Omit<LinkAsButtonProps, 'variant' | 'icon'> {}

export const LinkAsBackButton = ({ children, 'aria-label': ariaLabelProp, ...props }: Props): ReactElement => {
    const dictionary = useContext(DictionaryContext)
    const ariaLabel =
        ariaLabelProp ??
        (!children
            ? resolveIconButtonAriaLabel(dictionary, ICON_BUTTON_ARIA_LABEL_MESSAGE_KEYS.NAVIGATE_BACK)
            : undefined)

    return (
        <LinkAsButton
            data-testid="back-button"
            variant={ButtonVariants.QUIET}
            icon={<ArrowLeftIcon />}
            {...props}
            aria-label={ariaLabel}
        >
            {children}
        </LinkAsButton>
    )
}
